import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '../Tooltip';
import { classNames, shortenString } from '../../utils';
const ShortenedSpan = ({ maxStringLength, content, arrowDirection, extraClassNames = [], tooltipTextClassName, disableAutoAdjust, }) => {
    if (content.length <= maxStringLength) {
        return (_jsx("span", Object.assign({ className: classNames(extraClassNames.join()) }, { children: content }), void 0));
    }
    else {
        return (_jsx(Tooltip, Object.assign({ content: content, arrowDirection: arrowDirection, extraClassNames: extraClassNames, tooltipTextClassName: tooltipTextClassName, disableAutoAdjust: disableAutoAdjust }, { children: _jsx("span", Object.assign({ className: classNames(extraClassNames.join()) }, { children: shortenString(content, maxStringLength) }), void 0) }), void 0));
    }
};
export default ShortenedSpan;
